import React from 'react';

import { IModel } from 'models/company/interface';

import { useTranslation } from 'client/hooks';

import Founder from '../Founder';
import { ModalWrapper } from '../ModalWrapper';

import css from './FoundersPopup.module.scss';

interface Props {
  data: {
    companyId: string;
    team: IModel['team'];
  };
}

const FoundersPopup = ({ data }: Props) => {
  const { translate } = useTranslation();

  return (
    <ModalWrapper title={translate('popups.founders.title')}>
      <div className={css.personsWrapper}>
        <div className={css.persons}>
          {data.team.map((teamMember) => {
            return (
              <Founder
                companyId={data.companyId}
                key={teamMember.name}
                personInfo={teamMember}
                className={css.person}
              />
            );
          })}
        </div>
      </div>
    </ModalWrapper>
  );
};

export default FoundersPopup;
